<template>
    <div class="height100">
        <!--搜索时间头部-->
        <div class="flex mrl2 mrt5">
            <el-date-picker
                    :picker-options="pickerOptions"
                    size="mini"
                    v-model="defaultValue"
                    type="month"
                    :placeholder="$t('promanagement_select_month')"
                    format="yyyy-MM"
                    value-format="yyyy-MM"
                    :default-value="defaultValue"
                    :clearable="false">
            </el-date-picker>
            <el-button class="mrl15 " icon="el-icon-search" circle  @click="Search" size="mini"></el-button>
        </div>
        <div class="tree gdheight mrt10" id="gdtree">
            <el-tree
                    ref="tree"
                    :data="tableData"
                    node-key="i_id"
                    :props="defaultProps"
                    @node-click="handleNodeClick"
                    class="trees  video-tree height100"
                    default-expand-all
                    :highlight-current='highlighter'
                    :expand-on-click-node="false"
                    :current-node-key="currentNodekey">
                <span class="custom-tree-node" slot-scope="{ node, data }">
<!--
                    <el-tooltip class="item" effect="dark" :content="node.label" placement="top-start">
                        <span > {{ node.label | ellipsis(10) }} </span>
                    </el-tooltip>
-->
                    <span>{{ node.label }}</span>
                    <span>
                      <el-button
                              v-if="data.hasbutton==1||data.hasbutton==2||data.hasbutton==3||data.hasbutton==4"
                              type="text"
                              size="mini">
                        +
                      </el-button>
                    </span>
              </span>
            </el-tree>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {mapActions} from "vuex";
    export default {
        name: "TaskList",
        components: {},
        props:{
            tasklist:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                pickerOptions: {
                    disabledDate: (time) => {
                        const date = new Date()
                        const year = date.getFullYear()
                        let month = date.getMonth() + 1
                        if (month >= 1 && month <= 9) {
                            month = '0' + month
                        }
                        const currentdate = year.toString() + month.toString()
                        const timeyear = time.getFullYear()
                        let timemonth = time.getMonth() + 1
                        if (timemonth >= 1 && timemonth <= 9) {
                            timemonth = '0' + timemonth
                        }
                        const timedate = timeyear.toString() + timemonth.toString()
                        // 当月
                        // return timedate < currentdate || currentdate < timedate
                        // 当月及以后
                        // return timedate < currentdate
                        // 当月及以前
                        return timedate-1 > currentdate
                    }
                },


                i_show:1,
                //nowTime:"",
                //startTime:"",
                //endTime:"",
                highlighter:true,
                currentNodekey:"",
                //openAll:true,
                defaultValue:"",
                checkTimevalue:'',
                addData:[],
                inDex:0,
                mid:0,
                treeExpandData:[],
                expanded:false,
                times:"",
                //highlightCurrentRow:false,
                tableData: [
                    {
                        i_id:0,
                        i_type:0,
                        i_name:this.$t('promanagement_superior_1'),
                        vc_name:this.$t('promanagement_self-produced'),
                        children:[],
                        hasbutton:1,

                    },
                    {
                        i_id: 1,
                        i_type:1,
                        i_name:this.$t('promanagement_superior_2'),
                        vc_name:this.$t('promanagement_oem') ,
                        children:[],
                        hasbutton:2,

                    },
                    {
                        i_id: 2,
                        i_type:2,
                        i_name:this.$t('promanagement_superior_3'),
                        vc_name:this.$t('promanagement_r&d'),
                        children:[],
                        hasbutton:3,

                    },
                    {
                        i_id: 3,
                        i_type:3,
                        i_name:this.$t('promanagement_superior_4'),
                        vc_name:this.$t('promanagement_o&p'),
                        children:[],
                        hasbutton:4,

                    }
                ],
                ID:"",
                iType:0,
                selfPro: [],
                replacePro: [],
                // begin_time: "",
                // end_time: "",
                defaultProps: {
                    children: 'children',
                    label: 'vc_name'
                },
                Node:{},
            }
        },

        // watch:{
        //     tasklist(){
        //         if (this.tasklist){
        //             this.i_type=this.tasklist.i_type;
        //             this.addData=this.tasklist.data;
        //             console.log( this.addData,this.tasklist,"this.tasklist");
        //
        //         }
        //     },
        //
        //
        //     immediate:true,
        //     deep:true
        // },

        mounted() {


            this.getDateMonth();
            this.getScorderList();
            // this.$emit('getScorderList')
        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            append(data) {
                //console.log(data,"appendData");
                /*const newChild = {i_id:this.addData.i_id, label:this.addData.vc_name, children: [] };
                console.log(newChild,"newChild");
                if (!data.children) {
                    this.$set(data, 'children', []);
                }*/
                if (data.i_itype==0){
                    this.tableData[0].children.unshift(data.data);
                    // console.log(this.tableData);
                    this.currentNodekey = this.tableData[0].children[0].i_id;
                    this.$nextTick(() => {
                        this.$refs.tree.setCurrentKey(this.currentNodekey);
                    });
                    this.handleNodeClick(data.data,this.Node)
                    // this.ID=data.data.i_id;
                    // this.iType=data.data.i_type;
                    // let watchData = {
                    //     value: data.data,
                    //     title: "查看",
                    //     i_id:this.ID,
                    //     i_type:this.iType,
                    // };
                    // console.log(watchData,"watchData");
                    // this.$emit('getValue', watchData)
                }else if (data.i_itype==1){
                    this.tableData[1].children.unshift(data.data);
                    // console.log(this.tableData);
                    this.currentNodekey = this.tableData[1].children[0].i_id;
                    this.$nextTick(() => {
                        this.$refs.tree.setCurrentKey(this.currentNodekey);
                    });
                    this.handleNodeClick(data.data,this.Node)
                    // this.ID=data.data.i_id;
                    // this.iType=data.data.i_type;
                    // let watchData = {
                    //     value: data.data,
                    //     title: "查看",
                    //     i_id:this.ID,
                    //     i_type:this.iType,
                    // };
                    // console.log(watchData,"watchData");
                    // this.$emit('getValue', watchData)
                }else if (data.i_itype==2){
                    this.tableData[2].children.unshift(data.data);
                    // console.log(this.tableData);
                    this.currentNodekey = this.tableData[2].children[0].i_id;
                    this.$nextTick(() => {
                        this.$refs.tree.setCurrentKey(this.currentNodekey);
                    });
                    this.handleNodeClick(data.data,this.Node)
                    // this.ID=data.data.i_id;
                    // this.iType=data.data.i_type;
                    // let watchData = {
                    //     value: data.data,
                    //     title: "查看",
                    //     i_id:this.ID,
                    //     i_type:this.iType,
                    // };
                    // console.log(watchData,"watchData");
                    // this.$emit('getValue', watchData)
                }else if (data.i_itype==3){
                    this.tableData[3].children.unshift(data.data);
                    // console.log(this.tableData);
                    this.currentNodekey = this.tableData[3].children[0].i_id;
                    this.$nextTick(() => {
                        this.$refs.tree.setCurrentKey(this.currentNodekey);
                    });
                    this.handleNodeClick(data.data,this.Node)
                    // this.ID=data.data.i_id;
                    // this.iType=data.data.i_type;
                    // let watchData = {
                    //     value: data.data,
                    //     title: "查看",
                    //     i_id:this.ID,
                    //     i_type:this.iType,
                    // };
                    // console.log(watchData,"watchData");
                    // this.$emit('getValue', watchData)
                }
            },
            edit(data) {
                //console.log(data,"editData");
                this.tableData[data.i_itype].children = this.tableData[data.i_itype].children.filter(item => item.i_id !== data.data.i_id);
                this.tableData[data.newtype].children=[];
                this.iType=data.newtype;
                this.inDex=data.newtype;
                this.getScorderList(data);
            },

            Search(){
                // console.log("search", this.iType);
                this.tableData[0].children=[];
                this.tableData[1].children=[];
                this.tableData[2].children=[];
                this.tableData[3].children=[];
                this.getScorderList();
                // console.log(this.defaultValue)
                this.$emit('getNewDate',this.defaultValue)
                this.$emit('getValue', {})
                /*console.log(this.checkTimevalue,"timeee321",this.defaultValue);
                if (this.checkTimevalue>this.defaultValue){
                    console.log("1")
                }else{
                    console.log('2')
                }*/
            },


            handleNodeClick(data, node, it) {
                //console.log(this.defaultValue)
                this.$emit('getNewDate',this.defaultValue)
                //console.log(data, node, "ataaaaaaa");
                this.Node=node;
                this.highlighter=true;
                this.iType=data.i_type;
                //this.inDex=data.i_id;
                //console.log(data.i_id,"inDex");
                if (node.childNodes.length==0&&data.hasbutton!=null){
                    //console.log("length");
                    if (data.hasbutton==1){
                        this.inDex=data.i_id;
                        //this.inDex=0;
                        this.getScorderList();
                        let addData = {
                            i_id: 0,
                            i_type:0,
                            i_mid:this.mid,
                            i_show:this.i_show,
                        };
                        //console.log(addData,"1zzzzzzz");
                        this.$emit('getValue', addData)
                    }else if(data.hasbutton==2){
                        this.inDex=data.i_id;
                        //this.inDex=1;
                        this.getScorderList();
                        let addData = {
                            i_id: 0,
                            i_type:1,
                            i_mid:this.mid,
                            i_show:this.i_show,
                        };
                        //console.log(addData,"2sssssssssssss");
                        this.$emit('getValue', addData)
                    }else if(data.hasbutton==3){
                        this.inDex=data.i_id;
                        //this.inDex=1;
                        this.getScorderList();
                        let addData = {
                            i_id: 0,
                            i_type:2,
                            i_mid:this.mid,
                            i_show:this.i_show,
                        };
                        //console.log(addData,"3sssssssssssss");
                        this.$emit('getValue', addData)
                    }else if(data.hasbutton==4){
                        this.inDex=data.i_id;
                        //this.inDex=1;
                        this.getScorderList();
                        let addData = {
                            i_id: 0,
                            i_type:3,
                            i_mid:this.mid,
                            i_show:this.i_show,
                        };
                        //console.log(addData,"3sssssssssssss");
                        this.$emit('getValue', addData)
                    }
                }else{
                    //this.getScorderList();
                    if (data.hasbutton==1){
                    //    console.log("走上级1");
                        this.inDex=0;
                        /*console.log(this.checkTimevalue,this.defaultValue,"66666");
                        if (this.checkTimevalue>this.defaultValue){
                            this.i_show=0
                        }else{
                            this.i_show=1
                        }*/
                        let addData = {
                            i_id: 0,
                            i_type:0,
                            i_mid:this.mid,
                            i_show:this.i_show,
                            //checkTimevalue:this.checkTimevalue,
                            //defaultValue:this.defaultValue,
                        };
                        //console.log(addData,"上级1zzzzzzz");
                        this.$emit('getValue', addData)
                    }else if(data.hasbutton==2){
                    //    console.log("走上级2");
                        this.inDex=1;
                        /*console.log(this.checkTimevalue,this.defaultValue,"77777");
                        if (this.checkTimevalue>this.defaultValue){
                            this.i_show=0
                        }else{
                            this.i_show=1
                        }*/
                        let addData = {
                            i_id: 0,
                            i_type:1,
                            i_mid:this.mid,
                            i_show:this.i_show,
                            //checkTimevalue:this.checkTimevalue,
                            //defaultValue:this.defaultValue,
                        };
                        //console.log(addData,"上级2sssssssssssss");
                        this.$emit('getValue', addData)
                    }else if(data.hasbutton==3){
                        //    console.log("走上级3");
                        this.inDex=2;
                        /*console.log(this.checkTimevalue,this.defaultValue,"77777");
                        if (this.checkTimevalue>this.defaultValue){
                            this.i_show=0
                        }else{
                            this.i_show=1
                        }*/
                        let addData = {
                            i_id: 0,
                            i_type:2,
                            i_mid:this.mid,
                            i_show:this.i_show,
                            //checkTimevalue:this.checkTimevalue,
                            //defaultValue:this.defaultValue,
                        };
                        //console.log(addData,"上级3sssssssssssss");
                        this.$emit('getValue', addData)
                    }else if(data.hasbutton==4){
                        //    console.log("走上级3");
                        this.inDex=3;
                        /*console.log(this.checkTimevalue,this.defaultValue,"77777");
                        if (this.checkTimevalue>this.defaultValue){
                            this.i_show=0
                        }else{
                            this.i_show=1
                        }*/
                        let addData = {
                            i_id: 0,
                            i_type:3,
                            i_mid:this.mid,
                            i_show:this.i_show,
                            //checkTimevalue:this.checkTimevalue,
                            //defaultValue:this.defaultValue,
                        };
                        //console.log(addData,"上级3sssssssssssss");
                        this.$emit('getValue', addData)
                    }else if (data.hasbutton==null||data.hasbutton==undefined||data.hasbutton==''){
                        //console.log("只会走这里");
                        this.ID=data.i_id;
                        this.iType=data.i_type;
                        this.inDex=data.i_type;
                        let watchData = {
                            value: data,
                            title:this.$t('button_view'),
                            i_id:this.ID,
                            i_type:this.iType,
                            i_mid:this.mid,
                            i_show:this.i_show,
                        };
                        //console.log(watchData,"watchData");
                        this.isAccounting(watchData)
                        //this.$emit('getValue', watchData) 250804

                    }

                }
            },



            //接口（自产）
            async getScorderList(data) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param = {
                    i_mid: this.mid,
                    time:this.defaultValue,
                    i_type:this.iType,
                };
                let res = await API.getScorderList(param);
                if (res.code == 1) {
                    //console.log(this.inDex,'zxc')
                    this.selfPro=res.data;
                    this.tableData[this.inDex].children=this.selfPro;
                    if(data){
                        this.$nextTick(()=>{
                            if (data.newtype==0){
                                //this.tableData[0].children.unshift(data.data);
                                let idx = this.tableData[0].children.findIndex(item=>item.i_id==data.data.i_id)
                                this.currentNodekey = this.tableData[0].children[idx].i_id;
                                this.$nextTick(() => {
                                    this.$refs.tree.setCurrentKey(this.currentNodekey);
                                });
                                this.handleNodeClick(this.tableData[0].children[idx],this.Node)
                            }else if (data.newtype==1){
                                //this.tableData[1].children.unshift(data.data);
                                let idx = this.tableData[1].children.findIndex(item=>item.i_id==data.data.i_id)
                                this.currentNodekey = this.tableData[1].children[idx].i_id;
                                this.$nextTick(() => {
                                    this.$refs.tree.setCurrentKey(this.currentNodekey);
                                });
                                this.handleNodeClick(this.tableData[1].children[idx],this.Node)
                            }else if (data.newtype==2){
                                //this.tableData[2].children.unshift(data.data);
                                let idx = this.tableData[2].children.findIndex(item=>item.i_id==data.data.i_id)
                                this.currentNodekey = this.tableData[2].children[idx].i_id;
                                this.$nextTick(() => {
                                    this.$refs.tree.setCurrentKey(this.currentNodekey);
                                });
                                this.handleNodeClick(this.tableData[2].children[idx],this.Node)
                            }
                        })
                    }
                    /*this.nowTime=this.selfPro.dt_createtime;
                    this.startTime=this.selfPro.dt_starttime;
                    this.endTime=this.selfPro.dt_endtime;*/
                    // console.log(this.selfPro,this.tableData[this.inDex].children, this.inDex,"自产=0/代加工=1");
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            //代加工
            // async getReplaceScorderList() {
            //     let param = {
            //         i_mid: this.mid,
            //         time:this.times,
            //         i_type: 1
            //     };
            //     let res = await API.getScorderList(param);
            //     if (res.code == 1) {
            //         this.replacePro = res.data;
            //         //console.log(this.replacePro, "this.replacePro");
            //         this.getAll();
            //         //this.$message.success(res.message);
            //     } else if (res.code == -2) {
            //         this.$router.push('/login');
            //         this.$message.error(res.message);
            //     } else {
            //         this.$message.error(res.message);
            //     }
            // },

            //获取当月日期
            getDateMonth(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                //const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.defaultValue=`${date.getFullYear()}-${month}`;
                this.checkTimevalue=`${date.getFullYear()}-${month}`;
                //console.log(this.checkTimevalue,"timeee",this.defaultValue);
                //console.log(this.checkTimevalue,"checkTimevalue")
            },
            isAccounting(watchData){
                //console.log(watchData,'watchData');
                let nowtime = Number(watchData.value.dt_createtime);
                let rwendtime = Number(watchData.value.dt_endtime);
                //console.log('nowtime:',nowtime,'rwendtime:',rwendtime)
                if(nowtime>rwendtime){
                    const formatted =watchData.value.dt_endtime.slice(0, 4) + "-" + watchData.value.dt_endtime.slice(4, 6);
                    //console.log('formatted:',formatted)
                    this.getAccount(watchData,formatted)
                }else{
                    watchData.value.jz=null;
                    this.$emit('getValue', watchData)
                }
            },
            async getAccount(watchData,formatted){
                let param = {
                    i_gsid:watchData.value.i_gsid,
                    createTime:formatted,
                };
                //console.log('param',param)
                // let res={
                //     "code": 1,
                //     "message": "财务已结账",
                //     "data":  1 // 已结账 0 未结账
                // }
                let res = await API.isSettleAccounts(param);
                if (res.code == 1) {
                    if(res.data==1){
                        watchData.value.jz=true
                        this.$message.warning(this.$t('promanagement_the_current_financial_account_has_been_closed_and_no_subsequent_operations_can_be_added'))
                    }else{
                        watchData.value.jz=false
                    }
                    //console.log(watchData,'watchData--')
                    this.$emit('getValue', watchData)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    #gdtree::-webkit-scrollbar{
        display: none;
    }
    .gdheight{
        height:calc(100% - 70px);
        overflow: auto;
    }
    .height100{
        height:100%;
    }
    .el-tree {

    }
   /* .tree {
        overflow: auto;
        height: calc(90vh - 80px)
    }*/

    .flex{
        justify-content: left;
    }

    .mrt10{
        margin-top: 10px;
    }
    .mrt20{
        margin-top: 20px;
    }

    .mrl2{
        margin-left: 2px;
    }

    .mrl15{
        margin-left: 15px;
    }

    .mrt5{
       margin-top: 5px;
    }

    .mrr2{
        margin-right: 2px;
    }

    .el-date-editor.el-input, .el-date-editor.el-input__inner{
        width:260px;
    }

    /deep/ {
        .el-tree-node__expand-icon{
            color: black;
        }

        .el-tree-node__expand-icon.is-leaf {
            color: transparent;
            cursor: default;
        }
        .el-tree-node__label {
            font-size: 17px;
        }

    }

    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
    }
/*
    @media screen and (max-height: 770px) {
        .video-tree {
            //width: 420px;
            height: 530px;
        }
    }
    @media screen and (min-height: 900px) {
        .video-tree {
            //width: 530px;
            height: 685px;
        }
    }
    @media screen and (min-height: 780px) and (max-height: 830px) {
        .video-tree {
            //width: 450px;
            height: 610px;
        }
    }*/

    //实现滚动功能
    .video-tree {
       // overflow-y: auto;
       // max-height: calc(60vh);
       // min-height: calc(40vh);
    }


</style>